import { Snackbar } from "@chef/components";
import { OhSnap } from "@chef/icons/symbol";
import { DefiniteLoader } from "@chef/smart-components";
import { STAGE, usePreselector } from "@chef/state-management/hooks";

import { intl } from "./WelcomeBackSnackbar.Intl";

interface WelcomeBackSnackbarProps {
  isPausedAccount: boolean;
}

export const WelcomeBackSnackbar = ({
  isPausedAccount,
}: WelcomeBackSnackbarProps) => {
  const { stage, expire } = usePreselector({
    onStageChange: {
      [STAGE.COMPLETED]: () => {
        expire();
      },
      [STAGE.COMPLETED_WITH_ALLERGEN]: () => {
        expire();
      },
    },
    forcePoll: true,
  });

  const isPreselectorRunning = stage > STAGE.IDLE && stage < STAGE.COMPLETED;

  return (
    <Snackbar
      success
      showIcon={false}
      className="items-center justify-center p-5 pb-10 text-center shadow-2xl"
    >
      <div>
        <OhSnap className="w-10 h-10" />
      </div>
      <h1 className="pb-2 text-xl">
        <strong>{intl.WELCOME_BACK}</strong>
      </h1>
      {isPausedAccount && !isPreselectorRunning && (
        <>
          <p>{intl.YOU_HAVE_BEEN_GONE_FOR_A_WHILE}</p>
          <p>{intl.REACTIVATE_TO_SEE_DISHES}</p>
        </>
      )}
      {isPreselectorRunning && (
        <>
          <p>{intl.WE_ARE_PREPARING_YOUR_MENU}</p>
          <DefiniteLoader
            style="linear"
            stages={[
              { label: "", progress: 0 },
              {
                label: intl.SORTING_INGREDIENTS,
                progress: [10, 20],
              },
              {
                label: intl.CALCULATING_CALORIES_0,
                progress: [20, 30],
              },
              {
                label: intl.CALCULATING_CALORIES_1,
                progress: [30, 40],
              },
              {
                label: intl.PUTTING_TOGETHER_MENU_0,
                progress: [40, 55],
              },
              {
                label: intl.PUTTING_TOGETHER_MENU_1,
                progress: [55, 100],
              },
              { label: "", progress: 100 },
            ]}
            current={stage}
            className="mt-4 text-sm"
          />
        </>
      )}
      {!isPausedAccount && !isPreselectorRunning && (
        <p>{intl.WE_ARE_PREPARING_YOUR_MENU}</p>
      )}
    </Snackbar>
  );
};
